<template>
  <select v-model="selected" @change="changeFilter" >
    <option v-for="(option, optionIndex) in filterItem.filter_item_list"
            :key="'filter_item_' + optionIndex" :value="option.api_parameters" :data-adult="option.adult">
      {{option.title}}
    </option>
  </select>
</template>
<script>
import fp from 'lodash/fp'
import _ from 'lodash'
import { parse, parseUrl, stringify } from 'query-string'
import queryString from '@/common/utils/querystring'
import { sendEventLogSearchFilterChange } from '@/common/utils/log.v2.send'
import { LOG_SEND_LIST } from '@/common/resources/log.v2.const'

export default {
  name: 'FilterItem',
  props: {
    filterItem: {
      type: Object
    },
    selectedItems: {
      type: Object
    },
    getCurrentAdultFlagFn: {
      type: Function
    }
  },
  data () {
    return {
      selected: ''
    }
  },
  methods: {
    changeFilter () {
      const url = fp.flow(
        fp.getOr({}, 'query'),
        fp.thru(query => {
          let { query: apiQuery, url: apiUrl } = parseUrl(decodeURIComponent(_.get(query, 'api', '')))
          apiQuery = Object.assign(apiQuery, parse(this.selected))
          query.api = encodeURIComponent(`${apiUrl}?${stringify(apiQuery)}`)
          return _.assign({}, query, parse(this.selected))
        }),
        fp.set('page', '1'),
        fp.set('adult', this.getCurrentAdultFlagFn(this.filterItem, this.selected)),
        queryString.relativeUrlBuilder
      )(this.$route)
      try {
        if (LOG_SEND_LIST.includes(this.$route.name)) {
          sendEventLogSearchFilterChange({
            current: this.$route?.name,
            contentType: `${this.$route?.query?.category}${this.$route?.query?.mtype}`,
            selectedFilter: this.selected.replace('&orderby=', ''),
            landingUrl: url
          })
        }
        this.$router.push(url)
      } catch (e) { }
    },
    setSelected () {
      const { query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
      const getSelectedItem = fp.flow(
        fp.get(['filter_item_list']),
        fp.filter((item) => {
          const params = parse(item.api_parameters)
          const key = Object.keys(params)[0]
          if (query[key] === params[key]) {
            return item.api_parameters
          }
        })
      )
      if (getSelectedItem(this.filterItem).length === 0) {
        this.selected = _.get(this.filterItem, 'filter_item_list.0.api_parameters', '')
      } else {
        this.selected = _.get(getSelectedItem(this.filterItem), '0.api_parameters', '')
      }
    }
  },
  created () {
    this.setSelected()
  }
}
</script>
